// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c0f674b0","339":"976c28e7","355":"e0dbd6d2","453":"bcf54d8d","455":"b53580f0","541":"d2238855"}[chunkId] + ".chunk.js";
};